import React, { useEffect, useState } from "react";
import Breadcrumbs from "components/Common/Breadcrumb";
import { Col, Container, Row } from "reactstrap";
import BreadcrumbSub from "components/Common/BreadcrumbSub";
import { UserAnalyticsList } from "./UserAnalyticsList";
import { MetaTags } from "react-meta-tags";

const AnalyticsMainPage = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title></title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs
            title="User Analytics"
            breadcrumbItem="List"
          />
          <BreadcrumbSub
            subtile="Users Analytics List"
            SubBreadcrumbItem="Analytics"
          />

          <Row className=" mt-3">
            <Col>
              <UserAnalyticsList />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AnalyticsMainPage;
